import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { landingRoutes } from './routes/landing.routes';

// Combine routes
const router = createBrowserRouter([...landingRoutes]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
